export default __webpack_public_path__ + "static/media/019-air-compressor.832b4624.png";